import { Outlet } from 'react-router-dom';
import HeaderApp from '../components/core/HeaderApp';
import HomeHeader from '../components/HomeHeader';
import { Layout } from 'antd';
const { Content } = Layout;

const ContentLayout = ({ setAuthToken }) => {
    return (
        <Layout
             className='layout-container'>
            <Content>
                <HeaderApp setAuthToken={setAuthToken} />

                <div className='container-content'>
                    <HomeHeader />

                    <Outlet />
                </div>
            </Content>
        </Layout>
    )
}

export default ContentLayout;